import { PaginatedRequestParams } from "api";

export const withdrawQueryKeys = {
  all: ["wallet"] as const,
  lists: () => [...withdrawQueryKeys.all, "list"] as const,
  list: (filters: object) => [...withdrawQueryKeys.lists(), filters] as const,
  details: () => [...withdrawQueryKeys.all, "detail"] as const,

  detail: (id: string, params?: PaginatedRequestParams) =>
    [...withdrawQueryKeys.details(), id, params] as const,

  amountFilterConfig: () => ["withdraw", "amount-filter-config"],
};
